export default __webpack_public_path__ + "static/media/ITV_Policy_Device_Management.807e761c.png";